import React, { useState, useEffect, useRef } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { quantity, shoppingCartUrl, showInfo, quantityRestrictionsChanged } = useSelector(
        (state) => state.cart
    );
    const [isModalOpen, setModalOpen] = useState(false);
    const modalRef = useRef(null);
    
    const onToggle = () => dispatch(toggle());
    const closeModal = () => setModalOpen(false);

    useEffect(() => {
        if (quantityRestrictionsChanged) {
            setModalOpen(true);
        }
    }, [quantityRestrictionsChanged]);

    useEffect(() => {
        if (modalRef.current) {
            if (isModalOpen) {
                modalRef.current.showModal();
            } else {
                modalRef.current.close();
            }
        }
    }, [isModalOpen]);

    const renderModal = () => {
        return (
            <dialog ref={modalRef} className="contact-modal">
                <div className="contact-modal__header">
                    <h4>{translate('code.minicart.infomodal.title')}</h4>
                    <button onClick={closeModal}></button>
                </div>
                <div className="contact-modal__body">
                    <p>
                        {translate('code.minicart.infomodal.text')}
                    </p>
                </div>
            </dialog>
        );
    };

    return (
        <>
            <div className="cart cart--mini">
                <a
                    className="cart__link--block"
                    rel="nofollow"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onToggle();
                    }}
                >
                    <i className="cart__icon">
                        {quantity > 0 && (
                            <span className="cart__quantity">{quantity}</span>
                        )}
                    </i>
                </a>
                <div
                    className={`cart__info ${
                        !showInfo ? 'cart__info--hidden' : ''
                    }`}
                >
                    <span
                        className="cart__close-button"
                        onClick={() => onToggle()}
                    ></span>
                    <p className="cart__info-row">
                        {quantity} {translate('minicart.numberofproduct')}
                    </p>
                    <a href={shoppingCartUrl} className="cart__checkout-button">
                        {translate('code.minicart.shoppingcartlink')}
                    </a>
                </div>
            </div>
            {isModalOpen && renderModal()}
        </>
    );
};

export default MiniCart;
